// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
// @todo: Migrate to 'Dialog.Modal' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import * as Dialog from '@wandb/weave/components/Dialog';
import React, {useState} from 'react';

import {Analytics} from '../../../../services/analytics';
// eslint-disable-next-line import/no-cycle
import {AutomationStoreActions} from './AutomationStore';
import {useEventStore} from './EventStore';
import {EntryPoint} from './types';

export const SwitchToBasicButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const entryPoint = useEventStore(s => s.entryPoint);
  // we only allow this button to show up when basic mode is available
  if (entryPoint !== EntryPoint.WORKSPACE_PANEL) {
    return null;
  }
  return (
    <Dialog.Root open={isOpen} onOpenChange={setIsOpen}>
      <Dialog.Trigger>
        <Button active={isOpen} variant="secondary">
          Basic configuration
        </Button>
      </Dialog.Trigger>
      <Dialog.Portal>
        <Dialog.Overlay />
        <Dialog.Content>
          <Dialog.Title>Return to basic configuration?</Dialog.Title>
          <Dialog.Description>
            All changes to advanced configuration will be lost. Automation
            configuration will be reset.
          </Dialog.Description>
          <div className="mt-24 flex gap-8">
            <Dialog.Close>
              <Button
                variant="primary"
                onClick={() => {
                  Analytics.track('Automation Creation', {
                    type: 'click_basic_config',
                    entryPoint: 'create_trigger_drawer',
                  });
                  AutomationStoreActions.switchToBasicConfig();
                  setIsOpen(false);
                }}>
                Confirm
              </Button>
            </Dialog.Close>
            <Dialog.Close>
              <Button
                variant="ghost"
                onClick={() => {
                  Analytics.track('Automation Creation', {
                    type: 'click_basic_config_cancel',
                    entryPoint: 'create_trigger_drawer',
                  });
                  setIsOpen(false);
                }}>
                Cancel
              </Button>
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
